import { Leaf } from "lucide-react";

/** Loading skeleton grid shown while /plants is fetching. */
export const SkeletonGrid = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
    {[0,1,2,3,4,5,6,7].map((i) => (<div key={i} className="aspect-[5/6] rounded-3xl bg-parchment animate-pulse" />))}
  </div>
);

/** Zero-state shown when the user has no scans yet. */
export const EmptyState = ({ onStart, t }) => (
  <div className="text-center py-14" data-testid="empty-gallery">
    <div className="mx-auto w-14 h-14 rounded-full bg-parchment flex items-center justify-center text-leaf">
      <Leaf className="w-6 h-6" strokeWidth={1.5} />
    </div>
    <h3 className="font-display text-2xl mt-4 text-leaf-ink">{t("gallery.empty.title")}</h3>
    <p className="text-leaf-mist text-sm mt-1">{t("gallery.empty.sub")}</p>
    <button onClick={onStart} data-testid="empty-start-button"
      className="mt-6 rounded-full px-7 py-3 bg-leaf text-white hover:bg-leaf-deep transition">
      {t("gallery.empty.cta")}
    </button>
  </div>
);

/** Shown when filters + search return no matches. */
export const NoMatch = ({ onClear, t }) => (
  <div className="text-center py-10" data-testid="no-match">
    <p className="text-leaf-mist text-sm">{t("gallery.noMatch")}</p>
    <button onClick={onClear} data-testid="clear-filters-button" className="mt-4 text-leaf underline text-sm">
      {t("gallery.clearFilters")}
    </button>
  </div>
);
